<template>
  <div v-if="user">
    <div class="text-h6 mb-4">Utilisateur {{ user.first_name + ' ' + user.last_name }}</div>
    <v-row>
      <v-col md="4">
        <v-card>
          <v-card-title>Informations</v-card-title>
          <v-card-text>
            <pre style="white-space:pre-wrap; word-wrap:break-word;">{{ user }}</pre>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="8">
        <v-card>
          <v-card-title>Log</v-card-title>
          <v-card-text>
            <pre style="white-space:pre-wrap; word-wrap:break-word;">{{ log }}</pre>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'AdminUserPage',
  data () {
    return {
      user: null,
      log: null
    }
  },
  async created () {
    this.user = (await this.$api.get('users/' + this.$route.params.id, {
      with_subscriptions: true,
      with_customer: true,
    })).data

    this.log = (await this.$api.get('users/' + this.$route.params.id + '/log/raw')).data
  }
}
</script>